import React, { ReactNode } from "react"
import { Field, FieldRenderProps } from "react-final-form"
import SubmitError from "./SubmitError"
import Switch from "../controls/Switch"
import { fieldClass } from "../../utils/form";

interface SwitchFieldProps {
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  id?: string;
  i18nKey?: string;
  name: string;
}

const renderField = (renderProps: FieldRenderProps<number | string>): ReactNode => {
  const { children, className, disabled, id, input, i18nKey, meta } = renderProps;
  return (
    <div className={fieldClass(className, !!meta.submitError)}>
      <Switch i18nKey={i18nKey} input={{...input, disabled, id}}>{children}</Switch>
      <SubmitError errors={meta.submitError}/>
    </div>
  )
}

const SwitchField: React.FC<SwitchFieldProps> = (props: SwitchFieldProps) => {
  return (
    <Field
      {...props}
      render={renderField}
      type="checkbox"
    />
  )
}

export default SwitchField
